// @flow

import React, { PureComponent } from 'react';
import type { Element } from 'react';
import isServer from 'utils/isServer';
import PropTypes from 'prop-types';
import { gtmEventPush } from 'utils/gtm/events';
import isWorkingHours from 'utils/isWorkingHours';

// Components
import Button from 'Common/Button';
// Helpers
import styles from 'components/StickyCta.scss';
import classNames from 'classnames';

/**
 * StickyCta React component.
 */
class StickyCta extends PureComponent<*, *> {
  /**
   *  Props implementation.
   */
  static propTypes = {
    extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    phoneNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    targetScroll: PropTypes.object,
    item: PropTypes.object,
    openEnquiryModal: PropTypes.func
  };

  onClick = () => {
    const { phoneNumber } = this.props;
    const decodedNumber =
      !isServer() && phoneNumber ? window.atob(phoneNumber) : '';
    gtmEventPush({
      method: 'phoneNoClick',
      args: {
        actionPrefix: 'Mobile Sticky',
        sourceId: this.props.item.sourceId
      }
    });
    document.location.href = `tel:${decodedNumber}`;
  };

  handleEmailClick = e => {
    e.preventDefault();

    gtmEventPush({
      method: 'ctaEmailDealer',
      args: {
        actionPrefix: 'Mobile Sticky',
        sourceId: this.props.item.sourceId
      }
    });

    this.props.openEnquiryModal('message');
  };

  handleRequestCallbackButton = e => {
    e.preventDefault();

    gtmEventPush({
      method: 'ctaRequestCallback',
      args: {
        actionPrefix: 'Mobile Sticky',
        sourceId: this.props.item.sourceId
      }
    });

    this.props.openEnquiryModal('callback');
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Element<*> | null {
    const { classStickyCta } = styles;

    return (
      <div className={classNames([classStickyCta, this.props.extendStyle])}>
        {isWorkingHours() && this.props.phoneNumber && (
          <Button buttonText={'Call'} onClick={this.onClick} />
        )}
        {!isWorkingHours() && (
          <Button
            item={this.props.item}
            buttonText={'Request callback'}
            gaLabel="heycar-callback-dealer-button"
            onClick={this.handleRequestCallbackButton}
          />
        )}
        <Button
          item={this.props.item}
          buttonText={'Message'}
          gaLabel="heycar-message-dealer-button"
          onClick={this.handleEmailClick}
        />
      </div>
    );
  }
}

export default StickyCta;



// WEBPACK FOOTER //
// ./src/Detail/StickyCta/index.js